// extracted by mini-css-extract-plugin
export const arrow = "Tooltip__arrow__YZJUz";
export const arrowDown = "Tooltip__arrowDown__t6Eg4";
export const arrowUp = "Tooltip__arrowUp__re+vB";
export const arrowUpLeft = "Tooltip__arrowUpLeft__CtVzJ";
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const danger = "Tooltip__danger__TbfNv";
export const failure = "Tooltip__failure__llQjA";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const incorrect = "Tooltip__incorrect__pm1pV";
export const info = "Tooltip__info__nNqxc";
export const light = "Tooltip__light__yF0lt";
export const medium = "500";
export const member = "Tooltip__member__aNf6X";
export const others = "Tooltip__others__NuggA";
export const peers = "Tooltip__peers__+yyQY";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const success = "Tooltip__success__aRrmj";
export const tooltip = "Tooltip__tooltip__u+wHs font-faces__sansSemibold__K6NQF font-faces__sans__uCf65";
export const tooltipContent = "Tooltip__tooltipContent__jpuz+";
export const warning = "Tooltip__warning__RQiHE";
export const white = "Tooltip__white__Fr+Xm";
export const wrap = "Tooltip__wrap__ythtT";